import moment from 'moment';
import { useTranslation } from 'react-i18next';

export function useHourSaudation(): string {
  const currentHour = moment().hour();
  const { t } = useTranslation('translation', { keyPrefix: 'common' });

  if (currentHour >= 5 && currentHour < 12) {
    return t('goodMorning');
  } else if (currentHour >= 12 && currentHour < 18) {
    return t('goodAfternoon');
  } else {
    return t('goodEvening');
  }
}
